import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MatSort, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { ClientService } from '../../services/client.service';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'app-site-assets',
  templateUrl: './site-assets.component.html',
  styleUrls: ['./site-assets.component.scss']
})
export class SiteAssetsComponent implements OnInit {

  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['title', 'assettype', 'nextInspectionDate', 'lastInspectionDate'];
  sort: MatSort;
  paginator: MatPaginator
  filterActive: boolean = false
  afterFilter
  assetList = []
  siteTitle
  loading = false

  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    public _clientService: ClientService,
    public _utilityService: UtilityService
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    console.log("WHat is in the data", this.data);
    this.siteTitle = this.data.title
    this.updateData(this.data.assetList)
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }




  // UTILITY


  // Update data in table dynamically
  updateData(data) {
    console.log("UPDATING DATA = ", data)
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'assettype': return item.assetTypeId.type;
        case 'duration': return item.assetTypeId.inspectionDuration;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    if (this.data.assetList && !this.data.assetList.length)
      this.filterActive = true;
    this.afterFilter = {
      title: "No Assets!",
      data: "Sorry, no asset assigned to this site"
    }
  }



  // API CALL


  // Download single site pdf with assigned asset details
  downloadSitePrint() {
    this.loading = true
    const obj = {
      siteTitle: this.data.title,
      what3words: this.data.what3words,
      address: this.data.addressTitle,
      assetList: this.data.assetList
    }
    this._clientService.downloadSitePrint(obj).subscribe((pdfData) => {
      if (pdfData) {
        console.log("PDF DATA OF SINGLE SITE", pdfData);
        this._utilityService.handleSnackBar({ msg: "Site File Download Successfully", button: "Ok" })
      }
      this.loading = false
    }, error => {
      console.log("ERROR WHILE DOWNLOAD PDF", error);
      this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" })
      this.loading = false
    })
  }


}
